export default {
  catalog: 'Catalog',
  articles: 'Articles',
  faq: 'FAQ',
  // Account sub-navigation
  account: 'Account',
  dashboard: 'Dashboard',
  orders: 'Orders',
  favorites: 'Favorites',
  settings: 'Settings',
  billing: 'Billing',
  // Wallet
  wallet: 'Wallet',
  topUp: 'Top Up',
};
